import * as S from './style';

interface TextareaProps {
	value: string;
}

const Textarea = ({ value }: TextareaProps) => <S.Container>{value}</S.Container>;

export default Textarea;
